/**
 * Firebase App Check — modalità "enforce" su Firestore/Functions/Storage.
 *
 * In sviluppo usiamo un debug token autogenerato dal browser; in produzione
 * usiamo reCAPTCHA Enterprise. Vedi docs/setup-app-check.md per il
 * provisioning reCAPTCHA quando si va in prod.
 *
 * Vincoli:
 * - NIENTE chiave reCAPTCHA hardcoded (solo da `import.meta.env`).
 * - Init OBBLIGATORIO prima di qualsiasi chiamata a Auth/Firestore/Functions.
 * - L'oggetto restituito non viene esposto: serve solo a tener vivo il
 *   refresh interno dei token (auto-refresh abilitato).
 */

import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
  type AppCheck,
} from 'firebase/app-check';
import { app } from './firebase';

declare global {
  // Firebase App Check espone questa global in dev per attivare il debug token.
  var FIREBASE_APPCHECK_DEBUG_TOKEN: boolean | string | undefined;
}

let appCheck: AppCheck | null = null;

export function initAppCheck(): AppCheck | null {
  if (appCheck) return appCheck;

  if (import.meta.env.DEV) {
    if (typeof globalThis !== 'undefined') {
      globalThis.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
    }
  }

  const siteKey = import.meta.env.VITE_RECAPTCHA_ENTERPRISE_KEY;

  if (!siteKey) {
    if (!import.meta.env.DEV) {
      // In prod la chiave è obbligatoria. Loggata in modo generico per
      // l'observability: il dettaglio resta in console (no PII).
      console.error('[app-check] reCAPTCHA Enterprise site key mancante');
    }
    return null;
  }

  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(siteKey),
    isTokenAutoRefreshEnabled: true,
  });

  return appCheck;
}
